import API from './rpc.js';

import * as props from './utils';

if (!window.rpcjs) {
	window.rpcjs = { API, props: {...props} };
}

export default window.rpcjs;
